import { useTheme } from "@dropbox/dig-foundations";
import i18n from "@mirage/translations";
import StacksEmptyState from "./StacksEmptyState";

const BACKGROUND_IMAGE =
  "https://assets.dropbox.com/images/dashweb/emptystates/v3/company_stacks.png";
const DARK_BACKGROUND_IMAGE =
  "https://assets.dropbox.com/images/dashweb/emptystates/v3/company_stacks_dark.png";

export default function CompanyStacksEmptyState({
  className,
}: {
  className?: string;
}) {
  const { mode } = useTheme();
  const isDarkMode = mode === "dark";

  return (
    <StacksEmptyState
      className={className}
      title={i18n.t("company_stacks_empty_state_title")}
      message={i18n.t("company_stacks_empty_state_message")}
      imgSrc={isDarkMode ? DARK_BACKGROUND_IMAGE : BACKGROUND_IMAGE}
    />
  );
}
